export default "__VITE_ASSET__RZL$CAOX__"